export default "__VITE_ASSET__t_XGaV4f__"